import { useCallback } from 'react';

import { APP_SHELL_SIDEBAR_STORAGE_KEY } from '@/constants';
import useLocalStorageState from '@/data/hook/shared/useLocalStorageState';

export default function useShellSidebar() {
  const [isOpen, setIsOpen] = useLocalStorageState(
    APP_SHELL_SIDEBAR_STORAGE_KEY,
    false,
  );

  const toggle = () => setIsOpen(open => !open);
  const close = useCallback(() => setIsOpen(false), [setIsOpen]);

  return { isOpen, toggle, close };
}
